<article class="dashboard-container" *ngIf="!loading; else loaderBlock">
  <!----- START OF HEAD SECTION ------>
  <section class="header-section">
    <app-progress-tree></app-progress-tree>
    <!-- <div class="view">
      <div class="view-details">View Details</div>
    </div> -->
  </section>
  <!------ END OF HEAD SECTION ------->

  <!----- START OF CONTENT SECTION ------>
  <section class="content-section">
    <div class="content-section__left">
      <section>
        <label>Engagement Summary</label>
        <app-engagement-summary></app-engagement-summary>
      </section>
      <section *ngIf="persona === 'GCSP'">
        <app-common-expand-layout
          class="revenue"
          [tabs]="RevTabs"
          (tabChanged)="handleTabClick($event, 'rev')"
        >
          <ng-template #loaderBlock>
            <app-loader></app-loader>
          </ng-template>
          <div *ngIf="currentRevActiveTab == 'gdsIntegration'">
            <app-stacked-chart [chartData]="gdsIntegrationChartData" [keys]="gdsIntegrationKeyData"></app-stacked-chart>
          </div>  
          <div *ngIf="currentRevActiveTab == 'invoiceStatus'">
            <app-invoice-status></app-invoice-status>
          </div>   
          <div *ngIf="currentRevActiveTab == 'revenuePotential'">
            <app-revenue-potential [name]="'revenue_potential'"></app-revenue-potential>
          </div>         
        </app-common-expand-layout>
      </section>
      <section class="two-layout" *ngIf="persona === 'GCSP'">
        <app-common-expand-layout [title]="'Billable Hours'">
          <app-billable-hours></app-billable-hours>
        </app-common-expand-layout>
        <app-common-expand-layout
          [tabs]="csTabs"
          (tabChanged)="handleTabClick($event, 'sla')"
        >
          <div *ngIf="currentCtActiveTab === 'customerSatisfaction'">
            <app-satisfaction-graph
              [rating]="rating"
              *ngIf="clientDetails"
              [clientDetails]="clientDetails"
            ></app-satisfaction-graph>
          </div>
          <div *ngIf="currentCtActiveTab === 'slaCompliance'">
            <app-sla-complience
              *ngIf="clientDetails"
              [width]="width"
              [height]="height"
              [slaInformation]="slaInformation"
              [clientDetails]="clientDetails"
            ></app-sla-complience>
          </div>
        </app-common-expand-layout>
      </section>
      <section class="two-layout" *ngIf="persona !== 'GCSP'">
          <section class="initiatives">
            <label>Innovation and Productivity Initiatives</label>
            <div class="expand" (click)="goto('Innovation Productivity')" >
              <!--  motif-tooltip="View All Meetings" aria-label="view All"
            tooltip-color="alternate" placement="left" [hideOnScroll]="true" -->
              <img src="/assets/images/open.svg" alt="Expand" />
            </div>
            <div class="initiative-list">
              <div class="initiative-header">
                <div
                  class="menu"
                  *ngFor="let tab of initiativesTabs"
                  [ngClass]="{ active: tab?.active }"
                  (click)="tabClickHandler(tab)"
                >
                  <img [src]="tab?.active ? tab?.activeIcon : tab?.inActiveIcon" />
                  <label> {{ tab?.name }} ({{tab.count}})</label>
                </div>
              </div>
              <div class="list">
                <app-innovation-productivity
                  *ngFor="let initiative of initiativesData"
                  [initiativeData]="initiative"
                  [type]="activeInitiativeType.name"
                  (click)="goto('Innovation Productivity')" 
                ></app-innovation-productivity>
                <ng-container *ngIf="!initiativesData.length"><p class="no-data">No Data Found</p></ng-container>
              </div>
              <!-- <div class="initiative-footer">
                <div class="view-all">View All</div>
              </div> -->
            </div>
          </section>
          <section class="meetings">
            <label>Governance Meetings</label>
            <div class="expand" (click)="goto('Governance Meetings')" >
              <!--  motif-tooltip="View All Meetings" aria-label="view All"
            tooltip-color="alternate" placement="left" [hideOnScroll]="true" -->
              <img src="/assets/images/open.svg" alt="Expand" />
            </div>
            <div class="meeting-list">
              <div class="upcoming">
                <label>Upcoming</label>
                <ng-container *ngFor="let meeting of upcomingMeetings">
                  <app-meetings
                    [meeting]="meeting"
                    [type]="'upcoming'"
                  ></app-meetings>
                </ng-container>
              </div>
              <div class="past">
                <label>Past</label>
                <ng-container *ngFor="let meeting of pastMeetings | slice:0:3">
                  <app-meetings [meeting]="meeting" [type]="'past'"></app-meetings>
                </ng-container>
              </div>
              <!-- <div class="meeting-footer">
                <div class="view-all">View All</div>
              </div> -->
              <ng-container *ngIf="!meetingLoading; else loaderBlock"> </ng-container>
            </div>
          </section>
          <!-- case studies-client -->
      </section>
      <!-- transition widget -->
      <section class="transition" *ngIf="persona === 'GCSP'">
        <label>Transition</label>        
        <div class="expand" (click)="goto('Transition Page')" >          
          <img src="/assets/images/open.svg" alt="Expand" />
        </div>
        <app-transition class="talent-mgmt"></app-transition>
        <!-- <div class="engagement-summary">
          <app-risk-management></app-risk-management>
          <div class="engagement-footer">
            <div class="view-all">View All</div>
          </div>
        </div> -->
      </section>
      <section *ngIf="persona === 'GCSP'">
        <label>Talent Management</label>
        <app-team-utilization class="talent-mgmt"></app-team-utilization>
        <!-- <div class="engagement-summary">
          <app-risk-management></app-risk-management>
          <div class="engagement-footer">
            <div class="view-all">View All</div>
          </div>
        </div> -->
      </section>

      <section *ngIf="persona === 'GCSP'">
        <label>Risk Management</label>
        <app-risk-management></app-risk-management>
      </section>
    </div>
    <div class="content-section__right">
      <section>
        <label>Key Highlights</label>
        <div class="key-highlights">
          <app-key-highlights></app-key-highlights>
        </div>
      </section>
      <section class="meetings" *ngIf="persona === 'GCSP'">
        <label>Governance Meetings</label>
        <div class="expand" (click)="goto('Governance Meetings')" >
          <!--  motif-tooltip="View All Meetings" aria-label="view All"
        tooltip-color="alternate" placement="left" [hideOnScroll]="true" -->
          <img src="/assets/images/open.svg" alt="Expand" />
        </div>
        <div class="meeting-list">
          <div class="upcoming">
            <label>Upcoming</label>
            <ng-container *ngFor="let meeting of upcomingMeetings">
              <app-meetings
                [meeting]="meeting"
                [type]="'upcoming'"
              ></app-meetings>
            </ng-container>
          </div>
          <div class="past">
            <label>Past</label>
            <ng-container *ngFor="let meeting of pastMeetings">
              <app-meetings [meeting]="meeting" [type]="'past'"></app-meetings>
            </ng-container>
          </div>
          <ng-container *ngIf="!meetingLoading; else loaderBlock"> </ng-container>
        </div>
      </section>
      <section class="initiatives" *ngIf="persona === 'GCSP'">
        <label>Innovation and Productivity Initiatives</label>
        <div class="expand" 
        (click)="goto('Innovation Productivity')"  >
          <!--  motif-tooltip="View All Meetings" aria-label="view All"
        tooltip-color="alternate" placement="left" [hideOnScroll]="true" -->
          <img src="/assets/images/open.svg" alt="Expand" />
        </div>
        <div class="initiative-list">
          <div class="initiative-header">
            <div
              class="menu"
              *ngFor="let tab of initiativesTabs"
              [ngClass]="{ active: tab?.active }"
              (click)="tabClickHandler(tab)"
            >
              <img [src]="tab?.active ? tab?.activeIcon : tab?.inActiveIcon" />
              <label> {{ tab?.name }} ({{tab.count}})</label>
            </div>
          </div>
          <div class="list">
            <app-innovation-productivity
              *ngFor="let initiative of initiativesData"
              [initiativeData]="initiative"
              [type]="activeInitiativeType.name"
              (click)="goto('Innovation Productivity')" 
            ></app-innovation-productivity>
            <ng-container *ngIf="!initiativesData.length"><p class="no-data">No Data Found</p></ng-container>
          </div>
          <div class="initiative-footer">
            <!-- <div class="view-all">View All</div> -->
          </div>
        </div>
      </section>
      <section class="testimonials" *ngIf="persona === 'GCSP'">
        <label>Testimonials</label>
        <div class="testimonial-list">
          <app-testimonial></app-testimonial>
        </div>
      </section>
      <section class="case-studies">
        <label>Case Studies</label>
        <div class="case-studies-list">
          <app-case-study *ngIf="caseStudies.length" [data]="caseStudies"></app-case-study>
          <div class="noDataContaner" *ngIf="!caseStudies.length" >
            <span>No case studies yet</span>
          </div>
        </div>          
        <ng-container *ngIf="!caseStudiesLoading; else loaderBlock"> </ng-container>
      </section>
      <section class="quick-links" *ngIf="persona === 'GCSP'">
        <label>Quick links</label>
        <div class="links">
          <app-quick-link
            *ngFor="let link of quickLinks"
            [link]="link"
          ></app-quick-link>
        </div>
      </section>
    </div>
  </section>
  <button class="chat-button" (click)="toggleChatbot()">
    <img src="/assets/images/chat_icon.svg" alt="chat icon"/><span>Ask Me</span></button>
  <ng-template #countInfoSkeletonLoader>
    <div class="motif-skeleton-container loader-container">
      <span class="motif-skeleton-12 loader"></span>
    </div>
  </ng-template>
  <!------ END OF CONTENT SECTION ------->

  <!----- START OF LINE SECTION ------>
  <section class="line-section">
    <!-- <img src="/assets/images/dashboard_lines.svg" alt="Dashboard Lines"/> -->
  </section>
  <ng-container *ngIf="showChatbot" >
    <app-ms-chat (toggleChatbotParent)="toggleChatbot()"></app-ms-chat>
  </ng-container>
  <!------ END OF LINE SECTION ------->
</article>
<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>

